var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuTuBudynek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 709.63 768.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.46,321.4h-173.09v-93.35l-119.35-132.53V3.45h-9v92.09l-118.75,131.87v93.99H58.18c-32.13,0-58.18,26.04-58.18,58.17v388.8h304.13v-144.45h101.38v144.45h304.12v-388.8c0-32.13-26.04-58.17-58.17-58.17ZM141.18,598.92H58.75v-86.36h82.43v86.36ZM141.18,462.07H58.75v-86.36h82.43v86.36ZM269.18,598.92h-82.42v-86.36h82.42v86.36ZM269.18,462.07h-82.42v-86.36h82.42v86.36ZM397.18,462.07h-82.42v-86.36h82.42v86.36ZM525.18,598.92h-82.42v-86.36h82.42v86.36ZM525.18,462.07h-82.42v-86.36h82.42v86.36ZM653.19,598.92h-82.43v-86.36h82.43v86.36ZM653.19,462.07h-82.43v-86.36h82.43v86.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.32,43.19c-21.6-11.92-43.2,11.92-64.8,0V3.44c21.6,11.92,43.2-11.92,64.8,0v39.74Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuTuBudynek);
export default __webpack_public_path__ + "static/media/TuTuBudynek.82705e0ce162ea82d7080a6a83bb6213.svg";
export { ForwardRef as ReactComponent };